import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import createInfo from "./TestTopicInfoCreate.module.css";
import Select, { components } from "react-select";
import Swal from "sweetalert2";
import { customStyles } from "../../../../../pages/customStyles";
import { AxiosInstance } from "../../../../../axios";
import toast from "react-hot-toast";
import Loader from "../../../Loader";
import moment from "moment";
export default function TestTopicInfoCreate() {
  const { id } = useParams();
  const [aaOption, AAOption] = useState([
    {
      value: 0,
      label: "Course",
    },
    {
      value: 1,
      label: "Test",
    },
    {
      value: 3,
      label: "Special Class",
    },
    {
      value: 4,
      label: "Model Exam",
    },
    {
      value: 2,
      label: "Counselling",
    },
    {
      value: 5,
      label: "Mock Interview",
    },
  ]);
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;

  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("User Id cannot avaliable in session storage");
  }
  const navigate = useNavigate();
  const [ccategory, setCcategory] = useState([]);
  const [subcategorys, setSubcategorys] = useState([]);
  const [initialfields, setInitialfields] = useState({
    AAdmissionType: "",
    AAdmissionTypeLabel: "",
    Category: "",
    Category_ID: "",
    CourseGrouping: "",
    CourseGrouping_ID: "",
    Subject: "",
    Subject_ID: "",
    testTopic: "",
    CourseName: "",
    CourseName_ID: "",
    is_optional: "",
  });
  //  ref
  const test_topic = useRef(null);
  const type_of_admission_tt = useRef(null);
  const category_tt = useRef(null);
  const course_tt = useRef(null);
  const subject_tt = useRef(null);

  const [isLoading, setIsLoading] = useState(false);

  const [error, setError] = useState({});
  const [courseLi, setCourseLi] = useState([]);
  const [subjectLi, setSubjectLi] = useState([]);
  const [subject, setSubject] = useState([]);

  const [subjectTopics, setSubjectTopics] = useState([
    {
      id: 1,
      subject_name: null,
      subject_topics: [],
      subject_name_error: "",
      subject_topics_error: "",
    },
  ]);

  useEffect(() => {
    AxiosInstance.get("api/course/category_list")
      .then((res) => {
        const formatedCategory = res.data?.data?.map((item, index) => ({
          value: item.id,
          label: item.name,
        }));
        setCcategory(formatedCategory);
      })
      .catch((error) => {
        return error;
      });
  }, []);

  useEffect(() => {
    if (id) {
      AxiosInstance.post(`api/course/testview`, { id: id })
        .then((res) => {
          setIsLoading(true);
          if (res.data.status === true) {
            setIsLoading(false);
            let typeLabel;
            if (res.data.data[0].type === 0) {
              typeLabel = "Course";
            } else if (res.data.data[0].type === 1) {
              typeLabel = "Test";
            } else if (res.data.data[0].type === 2) {
              typeLabel = "Counselling";
            } else if (res.data.data[0].type === 3) {
              typeLabel = "SpecialClass";
            } else if (res.data.data[0].type === 4) {
              typeLabel = "ModelExam";
            } else if (res.data.data[0].type === 5) {
              typeLabel = "MockInterview";
            }

            setInitialfields({
              AAdmissionType: res.data.data[0].type,
              AAdmissionTypeLabel: typeLabel,
              Category: res.data.data[0].category_code,
              CourseGrouping: res.data.data[0].subcategory_code,
              Subject: res.data.data[0].subject,
              Subject_ID: res.data.data[0].subject_id,
              testTopic: res.data.data[0].test_topic_name,
              CourseName: res.data.data[0].course_name,
            });
          } else {
            setIsLoading(false);
            toast.error(res.data.message);
          }
        })
        .catch((error) => {
          setIsLoading(false);
          return error;
        });
    }
  }, [id]);

  useEffect(() => {
    if (
      initialfields.AAdmissionType !== "" &&
      initialfields.Category_ID !== ""
    ) {
      setCourseLi([]);
      AxiosInstance.post("/api/course/courselist", {
        type: [parseInt(initialfields.AAdmissionType)],
        category: [parseInt(initialfields.Category_ID)],
      })
        .then((res) => {
          if (res.data.status === true) {
            if (res.data.data.length > 0) {
              const SCourseLi = res.data.data.map((item) => ({
                value: item.id,
                label: item.course_name,
                subcategory: item.subcategory,
                subcategory_id: item.subcategory_id,
              }));
              setCourseLi(SCourseLi);
            } else {
              setCourseLi([]);
            }
          }
        })
        .catch((error) => {
          return error;
        });
    }
  }, [initialfields.AAdmissionTypeLabel, initialfields.Category_ID]);

  useEffect(() => {
    if (
      initialfields.AAdmissionType !== "" &&
      initialfields.Category_ID !== "" &&
      initialfields.CourseName_ID !== ""
    ) {
      AxiosInstance.post("/api/course/subjectlist", {
        type: [parseInt(initialfields.AAdmissionType)],
        category: [parseInt(initialfields.Category_ID)],
        course_id: [parseInt(initialfields.CourseName_ID)],
      })
        .then((res) => {
          if (res.data.status === true) {
            if (res.data.data.length > 0) {
              const SSubjectLi = res.data.data
                .filter((item) => item.optional_type === 0)
                .map((item) => ({
                  value: item.subject_master_id,
                  label: item.subject,
                }));

              setSubjectLi(SSubjectLi);
            } else {
              setSubjectLi([]);
            }
          }
        })
        .catch((error) => {
          return error;
        });
    }
  }, [
    initialfields.AAdmissionTypeLabel,
    initialfields.Category_ID,
    initialfields.CourseName_ID,
  ]);

  const handlechangeSelectDropdown = (option, dname) => {
    if (dname === "AAdmissionType") {
      if (option) {
        setInitialfields((prevState) => ({
          ...prevState,
          ["AAdmissionTypeLabel"]: option.label,
          ["AAdmissionType"]: option.value,
          ["CourseName_ID"]: "",
          ["Subject_ID"]: "",
          ["Subject"]: "",
          ["CourseName"]: "",
        }));
        setError({
          ...error,
          [dname]: "",
        });
      } else {
        setInitialfields((prevState) => ({
          ...prevState,
          ["AAdmissionTypeLabel"]: "",
          ["AAdmissionType"]: "",
          ["CourseName_ID"]: "",
          ["Subject_ID"]: "",
          ["Subject"]: "",
          ["CourseName"]: "",
        }));
      }
    } else if (dname === "Category") {
      if (option) {
        setInitialfields((prevState) => ({
          ...prevState,
          ["Category_ID"]: option.value,
          ["Category"]: option.label,
          ["CourseName_ID"]: "",
          ["Subject_ID"]: "",
          ["Subject"]: "",
          ["CourseName"]: "",
        }));
        setError({
          ...error,
          [dname]: "",
        });
      } else {
        setInitialfields((prevState) => ({
          ...prevState,
          ["Category_ID"]: "",
          ["Category"]: "",
          ["CourseName_ID"]: "",
          ["Subject_ID"]: "",
          ["Subject"]: "",
          ["CourseName"]: "",
        }));
      }
    } else if (dname === "CourseName") {
      setSubjectLi([]);
      setInitialfields((prevState) => ({
        ...prevState,
        ["Subject_ID"]: "",
        ["Subject"]: "",
      }));
      if (option) {
        setInitialfields((prevState) => ({
          ...prevState,
          ["CourseName_ID"]: option.value,
          ["CourseName"]: option.label,
          ["CourseGrouping_ID"]: option.subcategory_id,
          ["CourseGrouping"]: option.subcategory,
        }));
        setError({
          ...error,
          [dname]: "",
        });
      } else {
        setInitialfields((prevState) => ({
          ...prevState,
          ["CourseName_ID"]: "",
          ["CourseName"]: "",
          ["CourseGrouping_ID"]: "",
          ["CourseGrouping"]: "",
        }));
      }
    } else if (dname === "Subject") {
      if (option) {
        setInitialfields((prevState) => ({
          ...prevState,
          ["Subject_ID"]: option.value,
          ["Subject"]: option.label,
        }));
        setError({
          ...error,
          [dname]: "",
        });
      } else {
        setInitialfields((prevState) => ({
          ...prevState,
          ["Subject_ID"]: "",
          ["Subject"]: "",
        }));
      }
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    // let topics = value.split(",").map(topic => topic.trim()).filter(topic => topic !== "");
    // let commaCount = (value.match(/,/g) || []).length;
    // if (topics.length > 100 && commaCount > 99) {

    //   setError((prevFields) => ({
    //     ...prevFields,
    //     testTopic: "You can only provide up to 100 test topics",
    //   }));
    //   return;
    // }
    setInitialfields((prevFields) => ({
      ...prevFields,
      [name]: value,
    }));
    setError({
      ...error,
      [name]: "",
    });
  };

  const validateFieldss = (data, suTopics) => {
    const errors = {};
    if (data.AAdmissionType === "") {
      errors.AAdmissionType = id ? "" : "Please select type of admission";
    }
    if (!data.Category) {
      errors.Category = id ? "" : "Please select a category";
    }
    if (!data.CourseName) {
      errors.CourseName = id ? "" : "Please select a course";
    }
    if (!data.Subject) {
      errors.Subject = id ? "" : "Please select a subject";
    }
    if (!data.testTopic) {
      errors.testTopic = "Please enter topic";
    }
    if (suTopics.length > 0) {
      const UpdatesubTopic = suTopics.map((OB) => {
        let updatedOB = { ...OB };
        if (!OB.subject_name) {
          updatedOB.subject_name_error = "Please select a subject";
        }
        if (!OB.subject_topics || OB.subject_topics.length === 0) {
          updatedOB.subject_topics_error = "Please select a topic.";
        }
        return updatedOB;
      });
      setSubjectTopics(UpdatesubTopic);
    }
    validateFocusCommentSection(data, suTopics);
    return errors;
  };

  // focus the error fields in comment section
  const validateFocusCommentSection = (COMSECFO) => {
    if (!COMSECFO.testTopic) {
      test_topic.current.focus();
    } else if (!COMSECFO.AAdmissionType) {
      type_of_admission_tt.current.focus();
    } else if (!COMSECFO.Category) {
      category_tt.current.focus();
    } else if (!COMSECFO.CourseName) {
      course_tt.current.focus();
    } else if (!COMSECFO.Subject) {
      subject_tt.current.focus();
    }
  };

  const handleSubmit = () => {
    const err_bnh = validateFieldss(initialfields, subjectTopics);

    const testTopicArray = initialfields.testTopic
      ? initialfields.testTopic.split(",").map((item) => item.trim())
      : [];
    let topics = initialfields.testTopic
      .split(",")
      .map((topic) => topic.trim())
      .filter((topic) => topic !== "");
    let commaCount = (initialfields.testTopic.match(/,/g) || []).length;
    // Check for specific validation cases
    const tmp = {};
    const dupTestTopic = [];
    function formatWithAnd(arr) {
      if (arr.length <= 1) return arr.join("");
      if (arr.length === 2) return `${arr[0]} and ${arr[1]}`;
      return `${arr.slice(0, -1).join(", ")}, and ${arr[arr.length - 1]}`;
    }
    let hasDuplicate = false;
    for (const testTopic of testTopicArray) {
      if (tmp[testTopic]) {
        if (!dupTestTopic.includes(testTopic)) {
          dupTestTopic.push(testTopic);
        }
      } else {
        tmp[testTopic] = true;
      }
    }
    if (dupTestTopic.length > 0) {
      err_bnh.testTopic = `${formatWithAnd(
        dupTestTopic
      )}  are listed more than once. Please review and remove duplicates.`;
    }

    if (!initialfields.testTopic || initialfields.testTopic.trim() === "") {
      err_bnh.testTopic = "Please enter at least one topic";
    } else if (
      initialfields.testTopic.startsWith(",") ||
      initialfields.testTopic.endsWith(",")
    ) {
      err_bnh.testTopic = "Test topic cannot start or end with a comma";
    } else if (testTopicArray.some((item) => item === "")) {
      err_bnh.testTopic =
        "Test topic cannot contain empty values between commas";
    } else if (topics.length > 100 && commaCount > 99) {
      err_bnh.testTopic = "You can only provide up to 100  topics";
    }
    // If there are validation errors, set them and return early
    if (Object.keys(err_bnh).length > 0) {
      setError(err_bnh);
      return;
    }

    try {
      if (id) {
        const updateCoures = {
          id: parseInt(id),
          test_topic_name: initialfields.testTopic,
          subject_id: initialfields.Subject_ID,
        };
        AxiosInstance.post(`api/course/testEdit/`, updateCoures)
          .then((res) => {
            if (res.data.status) {
              toast.success(res.data.message);
              navigate(-1);
            } else {
              if (res.data?.topic_name_error) {
                setError((prev) => ({
                  ...prev,
                  testTopic: res.data.topic_name_error,
                }));
              } else {
                toast.error(res.data.message);
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        const createCouresInfoData = {
          test_topic: testTopicArray,
          type: initialfields.AAdmissionType,
          course_name: initialfields.CourseName,
          course_id: initialfields.CourseName_ID,
          subcategory: initialfields.CourseGrouping,
          category: initialfields.Category,
          subject_id: initialfields.Subject_ID,
          subject: initialfields.Subject,
          created_dt: moment().format("YYYY-MM-DD HH:mm:ss"),
          created_by: userid,
        };
        AxiosInstance.post(`api/course/TestAdd`, createCouresInfoData)
          .then((res) => {
            if (res.data.status) {
              toast.success(res.data.message);
              navigate("/CourseManagement/3");
            } else {
              if (res.data?.topic_name_error) {
                setError((prev) => ({
                  ...prev,
                  testTopic: res.data.topic_name_error,
                }));
              } else {
                toast.error(res.data.message);
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const navigateToPreviousScreen = () => {
    navigate(-1); // Navigate back by one step in the history
  };

  const handleSubjectOptionChange = async (option, id, name) => {
    if (name === "subject_name") {
      if (option) {
        const OptionSelected = {
          value: option.value,
          label: option.label,
        };
        setSubjectTopics((prevState) => {
          const isAlreadyExists = prevState.some(
            (q) => q.subject_name === OptionSelected.value
          );

          return prevState.map((q) => {
            if (q.id === id) {
              if (isAlreadyExists) {
                return {
                  ...q,
                  [name]: "",
                  subject_topics: [],
                  subject_name_error: "This subject is already selected.",
                };
              } else {
                return {
                  ...q,
                  [name]: OptionSelected.label,
                  subject_name_error: "",
                };
              }
            }
            return q;
          });
        });
      } else {
        setSubjectTopics((prevState) => {
          return prevState.map((q) => {
            if (q.id === id) {
              return {
                ...q,
                [name]: "",
                subject_topics: [],
                subject_name_error: "",
                subject_topics_error: "",
              };
            }
            return q;
          });
        });
      }
    } else if (name === "subject_topics") {
      if (option.length > 0) {
        const selectTestTopics = option.map((el) => ({
          value: el.value,
          label: el.value,
        }));
        setSubjectTopics((prevState) => {
          return prevState.map((q) => {
            if (q.id === id) {
              return {
                ...q,
                ["subject_topics"]: selectTestTopics,
                subject_topics_error: "",
              };
            }
            return q;
          });
        });
      } else {
        setSubjectTopics((prevState) => {
          return prevState.map((q) => {
            if (q.id === id) {
              return {
                ...q,
                subject_name: "",
                subject_topics: [],
                subject_name_error: "",
                subject_topics_error: "",
              };
            }
            return q;
          });
        });
      }
    }
  };

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div className={`${createInfo.CourseInfoSec} BathHeader global_container`}>
      <div className="row">
        <div className="col-md-6 col-12">
          <h2 className="TitleHeader">
            {id ? "Edit  Topic" : "Create New Topic"}
          </h2>
        </div>
        <div className="col-md-6 col-12 ListBtn">
          <ul class="List-Button">
            <li class="ListBtnItems">
              <Link
                to={id ? "javascript:void(0)" : "/CourseManagement/3"}
                onClick={id ? navigateToPreviousScreen : () => {}}
                className="secondaryButton "
                variant="secondary"
              >
                {id ? "Back to View  Topic" : "Back to Course Management"}
              </Link>
            </li>
            <li class="ListBtnItems">
              <Link
                to="javascript:void(0)"
                onClick={handleSubmit}
                className="primaryButton text-center "
                variant="primary"
              >
                Save Topic
              </Link>
            </li>
          </ul>
        </div>
        <div className="row m-0 mb-3">
          <fieldset className="mt-3">
            <legend className="w-auto"> Topic Details</legend>
            <form className="row g-3">
              <div class="col-12">
                <label
                  for="highlight_of_fact"
                  class="form-label confirm_value "
                >
                  Topic{" "}
                  {!id
                    ? "(You can add up to 100  topics, separated by commas)"
                    : ""}
                </label>
                <textarea
                  ref={test_topic}
                  className={`${createInfo.desc_input} w-100 rounded p-2 input-font-size`}
                  placeholder={
                    !id
                      ? "You can add up to 100  topics, separated by commas"
                      : ""
                  }
                  id="highlight_of_fact"
                  onChange={(e) => handleChange(e)}
                  value={initialfields.testTopic}
                  name="testTopic"
                  // maxLength={500}
                  style={{
                    height: "auto",
                    minHeight: "calc(24px * 8)",
                  }}
                ></textarea>
                {error.testTopic && (
                  <small className={createInfo.errors}>{error.testTopic}</small>
                )}
                {error.highlight_of_fact && (
                  <span className="error_message">
                    {error.highlight_of_fact}
                  </span>
                )}
              </div>
              <div className="col-md-6">
                <label
                  for="AAdmissionType"
                  className="form-label confirm_value"
                >
                  Type of Admission
                </label>
                <Select
                  ref={type_of_admission_tt}
                  className={`shadow-none input-font-size ${
                    id ? "disabled_btn" : ""
                  }`}
                  isDisabled={id ? true : false}
                  name="AAdmissionType"
                  value={
                    initialfields.AAdmissionType !== null &&
                    initialfields.AAdmissionType !== ""
                      ? {
                          value: initialfields.AAdmissionType,
                          label: initialfields.AAdmissionTypeLabel,
                        }
                      : null
                  }
                  onChange={(option) =>
                    handlechangeSelectDropdown(option, "AAdmissionType")
                  }
                  options={aaOption}
                  isSearchable={true} // Enables search functionality
                  placeholder="Select Type of Admission"
                  maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                  filterOption={(option, searchText) =>
                    option.label
                      .toLowerCase()
                      .includes(searchText.toLowerCase())
                  } // Filter options based on the search text
                  styles={customStyles} // Apply custom styles her
                />
                {error.AAdmissionType && (
                  <small className={createInfo.errors}>
                    {error.AAdmissionType}
                  </small>
                )}
              </div>
              <div class="col-md-6">
                <label for="Category" class="form-label confirm_value ">
                  Category
                </label>
                <Select
                  ref={category_tt}
                  className={`shadow-none input-font-size ${
                    id ? "disabled_btn" : ""
                  }`}
                  isDisabled={id ? true : false}
                  name="Category"
                  value={
                    initialfields.Category !== null &&
                    initialfields.Category !== ""
                      ? {
                          value: initialfields.Category_ID,
                          label: initialfields.Category,
                        }
                      : null
                  }
                  onChange={(option) =>
                    handlechangeSelectDropdown(option, "Category")
                  }
                  options={ccategory}
                  isSearchable={true} // Enables search functionality
                  placeholder="Select Category"
                  maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                  filterOption={(option, searchText) =>
                    option.label
                      .toLowerCase()
                      .includes(searchText.toLowerCase())
                  } // Filter options based on the search text
                  styles={customStyles} // Apply custom styles her
                />

                {error.Category && (
                  <small className={createInfo.errors}>{error.Category}</small>
                )}
              </div>

              <div class="col-md-6">
                <label for="CourseGrouping" class="form-label confirm_value ">
                  Course
                </label>
                <Select
                  ref={course_tt}
                  className={`shadow-none input-font-size ${
                    id ? "disabled_btn" : ""
                  }`}
                  isDisabled={id ? true : false}
                  name="CourseName"
                  value={
                    initialfields.CourseName !== null &&
                    initialfields.CourseName !== ""
                      ? {
                          value: initialfields.CourseName_ID,
                          label: initialfields.CourseName,
                        }
                      : null
                  }
                  onChange={(option) =>
                    handlechangeSelectDropdown(option, "CourseName")
                  }
                  options={courseLi
                    .filter((item) => item && item.label) // Filter out null and undefined elements
                    .sort((a, b) =>
                      a.label.trim().localeCompare(b.label.trim())
                    )}
                  isSearchable={true} // Enables search functionality
                  placeholder="Select Course"
                  maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                  filterOption={(option, searchText) =>
                    option.label
                      .toLowerCase()
                      .includes(searchText.toLowerCase())
                  } // Filter options based on the search text
                  styles={customStyles} // Apply custom styles her
                />
                {error.CourseName && (
                  <small className={createInfo.errors}>
                    {error.CourseName}
                  </small>
                )}
              </div>
              <div class="col-md-6">
                <label for="CourseGrouping" class="form-label confirm_value ">
                  Subject
                </label>
                <Select
                  ref={subject_tt}
                  className={`shadow-none input-font-size ${
                    id ? "disabled_btn" : ""
                  }`}
                  isDisabled={id ? true : false}
                  name="Subject"
                  value={
                    initialfields.Subject !== null &&
                    initialfields.Subject !== ""
                      ? {
                          value: initialfields.Subject_ID,
                          label: initialfields.Subject,
                        }
                      : null
                  }
                  onChange={(option) =>
                    handlechangeSelectDropdown(option, "Subject")
                  }
                  options={subjectLi
                    .filter((item) => item && item.label)
                    .sort((a, b) =>
                      a.label.trim().localeCompare(b.label.trim())
                    )}
                  isSearchable={true} // Enables search functionality
                  placeholder="Select Subject"
                  maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                  filterOption={(option, searchText) =>
                    option.label
                      .toLowerCase()
                      .includes(searchText.toLowerCase())
                  } // Filter options based on the search text
                  styles={customStyles} // Apply custom styles her
                />
                {error.Subject && (
                  <small className={createInfo.errors}>{error.Subject}</small>
                )}
              </div>
            </form>
          </fieldset>

          <div className="offset-md-12 col-12 ListBtn pt-2">
            <ul class="List-Button">
              <li class="ListBtnItems">
                <Link
                  to={id ? "javascript:void(0)" : "/CourseManagement/3"}
                  onClick={id ? navigateToPreviousScreen : () => {}}
                  className="secondaryButton "
                  variant="secondary"
                >
                  {id ? "Back to View Topic" : "Back to Course Management"}
                </Link>
              </li>
              <li class="ListBtnItems">
                <Link
                  to="javascript:void(0)"
                  onClick={handleSubmit}
                  className="primaryButton text-center "
                  variant="primary"
                >
                  Save Topic
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
